import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import ToastNotification from '../ToastNotification/ToastNotification';
import RegisterPassword3 from '../RegisterPassword3/RegisterPassword3';

const RegisterPassword2 = () => {
    const [formData, setFormData] = useState({
        birthDate: '',
        cpf: ''
    });
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState({ show: false, message: '', type: '' });
    const [isValidated, setIsValidated] = useState(false);

    const showMessage = (msg, type) => {
        setToast({ show: true, message: msg, type: type });
        setTimeout(() => setToast(prev => ({ ...prev, show: false })), 5000);
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserId(decoded.userId || decoded.sub);
            } catch (error) {
                console.error("Erro ao decodificar token:", error);
                showMessage("Sessão inválida.", "error");
            }
        }
    }, []);

    // --- LÓGICA DE MÁSCARAS ---
    const handleChange = (e) => {
        const { name, value } = e.target;
        let formattedValue = value;

        if (name === 'birthDate') {
            // Remove letras e aplica máscara DD/MM/AAAA
            formattedValue = value.replace(/\D/g, "");
            if (formattedValue.length > 2 && formattedValue.length <= 4) {
                formattedValue = formattedValue.replace(/^(\d{2})(\d)/, "$1/$2");
            } else if (formattedValue.length > 4) {
                formattedValue = formattedValue.replace(/^(\d{2})(\d{2})(\d)/, "$1/$2/$3");
            }
            formattedValue = formattedValue.substring(0, 10);
        }

        if (name === 'cpf') {
            // Remove letras e aplica máscara 000.000.000-00
            formattedValue = value.replace(/\D/g, "");
            formattedValue = formattedValue
                .replace(/(\d{3})(\d)/, "$1.$2")
                .replace(/(\d{3})(\d)/, "$1.$2")
                .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
            formattedValue = formattedValue.substring(0, 14);
        }

        setFormData(prev => ({ ...prev, [name]: formattedValue }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const token = localStorage.getItem('token');

        try {
            const response = await axios.post(
                `https://phantomtech.com.br/AutomaTech/api/credentials/checkDataToInitValidation?userId=${userId}`,
                {
                    birthDate: formData.birthDate, // Já vai com as barras
                    cpf: formData.cpf.replace(/\D/g, '') // Limpa os pontos/traço para o envio
                },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (response.status === 200) {
                showMessage(response.data.message || "Dados validados!", "success");
                setTimeout(() => setIsValidated(true), 2000);
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Erro ao validar dados.';
            showMessage(errorMsg, 'error');
        } finally {
            setLoading(false);
        }
    };

    if (isValidated) return <RegisterPassword3 />;

    return (
        <div className="container vh-100 d-flex justify-content-center align-items-center">
            <ToastNotification
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ ...toast, show: false })}
            />

            <div className="col-12 col-md-8 col-lg-5">
                <div className="card shadow-sm border-primary">
                    <div className="card-body p-4">
                        <h3 className="card-title text-center mb-1">Passo 2</h3>
                        <p className="text-center text-muted mb-4">Validação de identidade</p>
                        
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label fw-bold small text-secondary">Data de Nascimento</label>
                                <input
                                    type="text"
                                    name="birthDate"
                                    className="form-control form-control-lg"
                                    placeholder="DD/MM/AAAA"
                                    value={formData.birthDate}
                                    onChange={handleChange}
                                    maxLength="10"
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label fw-bold small text-secondary">CPF</label>
                                <input
                                    type="text"
                                    name="cpf"
                                    className="form-control form-control-lg"
                                    placeholder="000.000.000-00"
                                    value={formData.cpf}
                                    onChange={handleChange}
                                    maxLength="14"
                                    required
                                />
                            </div>

                            <div className="d-grid mt-4">
                                <button type="submit" className="btn btn-primary btn-lg fw-bold" disabled={loading}>
                                    {loading ? 'Validando...' : 'ENVIAR'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterPassword2;